import './App.css';
// import About from './components/HomePage/AboutUs/About';
import Footer from './components/Footer';
import NavBar from './components/NavBar';
import Contact from './components/ContactPage/Contact';
import { createBrowserRouter, Outlet } from "react-router-dom";
import Home from './components/HomePage/Home';
import AboutPage from './components/AboutPage/AboutPage';
import Product from './components/ProductPage/Product';
import Blog from './components/BlogPage/Blog';
import ProductDetail from './components/ProductDetailPage/ProductDetail';
import BlogDetail from './components/BlogDetailPage.jsx/BlogDetail';
// import HomeSlider from './components/HomePage/HomeSlider/HomeSlider';
import TermsCondition from './components/TermsCondition/TermsCondition';
import PrivacyPolicy from './components/TermsCondition/PrivacyPolicy';
import CategoryDetail from './components/ProductDetailPage/CategoryDetail';


function App() {
  return (
    <div className="App">
      <NavBar/>
        <Outlet/>
      <Footer/>
    </div>
  );
}
export const appRouter = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <Home/>
      },
      {
        path: "/about",
        element: <AboutPage/>
      },
      {
        path: "/blog",
        element: <Blog/>
      },
      {
        path: "/contact",
        element: <Contact/>
      },
      {
        path: "/product",
        element : <Product/>
      },
      {
        path : "/category-detail/:category",
        element : <CategoryDetail/>
      },
      {
        path : "product/productdetail/:id/:proid",
        element : <ProductDetail/>
      },
      {
        path : "/blogdetail/:blogId",
        element : <BlogDetail/>
      },
      {
        path : "terms",
        element : <TermsCondition/>
      },
      {
        path : "privacy",
        element : <PrivacyPolicy/>
      }
      
    ]
  },

  

]);

export default App;
